var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"content",class:_vm.$isMobile && 'content-mobile'},[_c('comp-room',{ref:"compRoom",attrs:{"cameraId":_vm.cameraId,"microphoneId":_vm.microphoneId,"userId":_vm.userId,"videoMediationMode":_vm.videoMediationMode,"roomId":Number(_vm.roomId)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }